import angular from 'angular';
import components from './components';

export default angular.module('insuranceQuoteOpportunities.scenes', [
  components,
]).name;
